<template>
  <div>
    
    <b-card
      no-body
      class="border-secondary"
    >
      <b-card-body>
        
        <validation-observer ref="organizationalUnitform">

          <b-form @submit.prevent="save">

            <div class="vx-row">
              <div class="vx-col sm:w-6/12 w-full">

                <b-form-group
                  label="Nome"
                  label-for="name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                  >
                    <b-form-input
                      id="name"
                      v-model="organizationalUnit.name"
                      :state="errors.length > 0 ? false:null"
                      name="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                
              </div>
              
              <div class="vx-col sm:w-4/12 w-full">

                <b-form-group
                  label="Abreviação"
                  label-for="initials"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="initials"
                  >
                    <b-form-input
                      id="initials"
                      v-model="organizationalUnit.initials"
                      :state="errors.length > 0 ? false:null"
                      name="initials"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

              </div>

              <div class="vx-col sm:w-2/12 w-full">

                <b-form-group
                  label="Terceirizada"
                  label-for="outsourced"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="outsourced"
                  >
                    <b-form-checkbox
                      v-model="organizationalUnit.outsourced"
                      class="mr-0 mt-50"
                      name="outsourced"
                      switch
                      inline
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

              </div>
            </div>

            <div class="vx-row mt-2">
              
              <div class="vx-col sm:w-1/2 w-full">

                <b-form-group
                  label="Nível"
                  label-for="level"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="level"
                  >
                    <b-form-radio-group
                      v-model="organizationalUnit.level"
                      :options="levels"
                      :state="levelState"
                      class="demo-inline-spacing"
                      name="level"
                    ></b-form-radio-group>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

              </div>

            </div>

            <div class="vx-row">
              <div class="vx-col w-full">

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  type="submit"
                  class="float-right"
                >
                  Salvar
                </b-button>

              </div>
            </div>
          </b-form>

          <OrganizationalUnitSponsor :services="services" :organizationalUnit="organizationalUnit"></OrganizationalUnitSponsor>

          <div class="vx-row">
            <div class="vx-col w-full">

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                @click="destroy(organizationalUnit)"
                class="float-right"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                />
                <span class="align-middle">Remover</span>
              </b-button>

            </div>
          </div>
          
        </validation-observer>

      </b-card-body>
    </b-card>
    
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { 
  BForm, 
  BButton, 
  BFormInput, 
  BFormGroup, 
  BFormRadioGroup, 
  BFormCheckbox,
  BCard,
  BCardBody
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'

import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import OrganizationalUnitSponsor from './OrganizationalUnitSponsor.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    OrganizationalUnitSponsor,
    Datepicker,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormCheckbox,
    BCard,
    BCardBody,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    people_id: {
      type: Number,
      default: null
    },
    services: {
      type: Object,
      default: null
    },
    organizationalUnit: {
      type: Object,
      default: {
        name: '',
        initials: '',
        outsourced: false,
        level: null,
      }
    }
  },
  data: () => ({
    parentEntity: null,
    levels: [
      { text: 'Estratégico', value: 'strategic' },
      { text: 'Tático', value: 'tatical' },
      { text: 'Operacional', value: 'operational' },
    ],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    levelState() {
      return Boolean(this.level)
    },
    validateForm() {
      // return (
      //   !this.isEmpty(this.address.addressType) &&
      //   !this.isEmpty(this.address.streetName) &&
      //   !this.isEmpty(this.address.city)
      // )
      return true
    }
  },
  watch: {},
  methods: {
    save() {
      
      this.clearErrors(this.$refs.organizationalUnitform)
      this.$vs.loading()

      const params = {
        id: this.organizationalUnit.id,
        name: this.organizationalUnit.name,
        initials: this.organizationalUnit.initials,
        level: this.organizationalUnit.level,
        outsourced: this.organizationalUnit.outsourced
      }

      this.services.organizationalUnitService.createOrUpdate(params).then(data => {
        this.$vs.loading.close()
        this.notifySuccess(this.$vs)
      }, error => {
        this.$vs.loading.close()
        this.showErrors(this.$refs.organizationalUnitform, error)
      })
      
    },
    destroy(organizationalUnit) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja remover esta Unidade Organizacional?',
        accept: () => {
          this.$emit('destroy', organizationalUnit)
        }
      })
    }
  },
  beforeMount() {},
  mounted() {

    this.$root.$on('naturalEntityCreated', naturalEntity => {
      if (this.naturalEntity) {
        this.sponsor = naturalEntity
      }
    })

    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']
    })

    this.$root.$on('legalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['legalEntity/legalEntity']
    })
  }
}
</script>